import {toast} from "react-toastify";

// Define the sendNoty function
const sendNoty = (
    type,
    layout,
    text,
    timeout = 5000,
    theme = 'light',
    // Destructure the options object with default values
    {
        theme: optionTheme = theme,
        position = layout,
        autoClose = timeout,
        hideProgressBar = false,
        closeOnClick = true,
        pauseOnHover = true,
        draggable = true,
        progress
    } = {}
) => {
    // Create the options object with the destructured values
    const options = {
        theme: optionTheme,
        position,
        autoClose,
        hideProgressBar,
        closeOnClick,
        pauseOnHover,
        draggable,
        progress
    };

    // Check if the type is valid, otherwise show an error toast and return
    if (!['success', 'info', 'warning', 'error', 'default'].includes(type)) {
        toast('Set type correctly', options);
        return;
    }

    // Show the appropriate toast based on the type and the options
    toast[type](text, options);
};

export default sendNoty;
